import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CssVarsProvider } from '@mui/joy/styles';
import CssBaseline from '@mui/joy/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { HelmetProvider } from 'react-helmet-async';

import { theme } from './theme';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { CapabilitiesSection } from './components/CapabilitiesSection';
import { TechStackSection } from './components/TechStackSection';
import { ProjectGeneratorSection } from './components/ProjectGeneratorSection';
import AboutPage from './components/AboutPage';
import ContactPage from './components/ContactPage';
import BlogPage from './components/BlogPage';
import BlogAllPage from './components/BlogAllPage';
import BlogPostPage from './components/BlogPostPage';
import AdminLoginPage from './components/AdminLoginPage';
import AdminLayout from './components/AdminLayout';
import AdminDashboard from './components/AdminDashboard';
import AdminBlogEditor from './components/AdminBlogEditor';


function App() {
  return (
    <HelmetProvider>
    <CssVarsProvider theme={theme} defaultMode="dark">
      <CssBaseline />
      <Router>
        <div style={{
          minHeight: '100vh',
          background: 'linear-gradient(135deg, #000000 0%, #020617 100%)',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Background effects */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: `
              radial-gradient(circle at 20% 20%, rgba(11, 75, 179, 0.3) 0%, transparent 50%),
              radial-gradient(circle at 80% 80%, rgba(0, 212, 255, 0.2) 0%, transparent 50%),
              radial-gradient(circle at 40% 60%, rgba(0, 255, 136, 0.1) 0%, transparent 50%)
            `,
            zIndex: 1
          }} />

          <div style={{ position: 'relative', zIndex: 2 }}>
            <Routes>
              <Route path="/admin" element={<AdminLoginPage />} />
              <Route path="/admin/*" element={<AdminLayout />}>
                <Route path="dashboard" element={<AdminDashboard />} />
                <Route path="blog/new" element={<AdminBlogEditor />} />
                <Route path="blog/edit/:id" element={<AdminBlogEditor />} />
              </Route>
              <Route path="/" element={
                <>
                  <Header />
                  <HeroSection />
                </>
              } />
              <Route path="/about" element={
                <>
                  <Header />
                  <AboutPage />
                </>
              } />
              <Route path="/contact" element={
                <>
                  <Header />
                  <ContactPage />
                </>
              } />
              <Route path="/blog" element={
                <>
                  <Header />
                  <BlogPage />
                </>
              } />
              <Route path="/blog/all" element={
                <>
                  <Header />
                  <BlogAllPage />
                </>
              } />
              <Route path="/blog/:slug" element={
                <>
                  <Header />
                  <BlogPostPage />
                </>
              } />
            </Routes>

            {/* Rest of home page sections */}
            <Routes>
              <Route path="/" element={
                <>
                  <CapabilitiesSection />
                  <TechStackSection />
                  <ProjectGeneratorSection />
                </>
              } />
            </Routes>
          </div>
          
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </div>
      </Router>
    </CssVarsProvider>
    </HelmetProvider>
  );
}

export default App;
